import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import { style } from "../styles/Style";
import { signOut } from "../store/actions/AuthActions";
function Logout() {
  const state = useSelector((state) => state);
  console.log(state);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(signOut());
    history.push("/");
  };
  return (
    <div className="w-full flex h-screen bg-indigo-500">
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="m-auto w-80 p-4 bg-white rounded">
        <h2 className="text-indigo-500 py-2">Confirm</h2>
        <p className="text-xs text-gray-500">
          You are already logged in as Fiston Nshimiyandinze, you need to log
          out before logging in as different user.
        </p>
        <div className="flex">
          <button
            type="submit"
            className={style.loginBtn}
            onClick={() => {
              handleSignOut();
            }}
          >
            <p className="m-auto">Log out</p>
          </button>
          <Link type="submit" to="/home" className={style.cancelBtn}>
            <p className="m-auto">Cancel</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Logout;
